import React from 'react';

const FinanceiroIco = () => {
  return (
    <svg width="1.5rem" height="1.5rem" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 315 420">
      <path d="M299.6,15.4C289.8,5.6,276.4,0,262.5,0h-210C23.5,0,0,23.5,0,52.5v350c0,9.7,7.8,17.5,17.5,17.5c3.8,0,7.5-1.2,10.5-3.5
	l59.5-44.6l49,36.8c12.5,9.3,29.5,9.3,42,0l49-36.8l59.5,44.6c7.7,5.8,18.7,4.2,24.5-3.5c2.3-3,3.5-6.7,3.5-10.5v-350
	C315,38.6,309.4,25.2,299.6,15.4z M196.9,225.1c-4.7,12.8-15.3,22.5-28.4,26v14.2c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9V251
	c-10-2.6-18.6-8.9-24.2-17.5c-3.5-4.9-2.4-11.7,2.5-15.3s11.7-2.4,15.3,2.5c0.2,0.3,0.5,0.7,0.6,1c5.9,9.2,18.2,11.9,27.5,5.9
	c9.2-5.9,11.9-18.2,5.9-27.5c-3.6-5.6-9.9-9.1-16.6-9.1c-23,0.1-41.8-18.4-41.9-41.4c-0.1-19,12.6-35.6,30.9-40.5V94.7
	c0-6,4.9-10.9,10.9-10.9s10.9,4.9,10.9,10.9V109c11.5,3.2,21.1,11.2,26.3,22c2.6,5.4,0.4,12-5.1,14.6c-5.4,2.6-12,0.4-14.6-5.1
	c-4.8-9.8-16.7-13.9-26.6-9.1c-9.8,4.8-13.9,16.7-9.1,26.6c3.4,6.9,10.5,11.2,18.2,11.1c23-0.1,41.8,18.4,41.9,41.4
	C199.4,215.6,198.6,220.4,196.9,225.1z"/>
    </svg>

  )
}

export default FinanceiroIco;